export default __webpack_public_path__ + "static/media/thelogo.7ac9c8f6.gif";